import type { IBlotterPreferenceState } from 'components/shared/Blotter/Grid/blotter.model';
import type { BlotterType } from 'models/blotters/BlotterType';
import type { Observable } from 'rxjs';
import { ignoreElements, map } from 'rxjs/operators';
import type { IHttpClient } from 'utils/http/httpClient.model';

export type BlotterPreferencePayload = {
  data: IBlotterPreferenceState;
  version: 1 | 2;
};

export interface IPersistPreferenceStateApi {
  saveState(state: IBlotterPreferenceState, blotterType: BlotterType): Observable<never>;
}

export interface ILoadPreferenceStateApi {
  getState(blotterType: BlotterType): Observable<BlotterPreferencePayload | undefined>;
}

export type IPreferenceStateApi = IPersistPreferenceStateApi & ILoadPreferenceStateApi;

export const blotterPreferenceStatePersistenceApiConnector = (http$: IHttpClient): IPreferenceStateApi => ({
  saveState(data: IBlotterPreferenceState, blotterType: BlotterType) {
    const body: BlotterPreferencePayload = { version: 2, data };
    return http$
      .post({
        url: `api/v2/blotter-preference-state/${blotterType}`,
        body,
      })
      .pipe(ignoreElements());
  },
  getState(blotterType: BlotterType) {
    return http$
      .getJSON<BlotterPreferencePayload>({
        url: `api/v2/blotter-preference-state/${blotterType}`,
        headers: {
          Pragma: 'no-cache',
          'Cache-Control': 'no-cache',
        },
      })
      .pipe(map(({ status, payload }) => (status === 204 ? undefined : payload)));
  },
});
